import "./app.css";
import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { ThemeProvider } from "@material-ui/core/styles";
import { materialTheme } from "app/theme";
import GlobalStyles from "app/styles/GlobalStyles";
import Loader from "app/components/Loader";
import { rootRoutes } from "./Routes";

const App = () => {
  return (
    <ThemeProvider theme={materialTheme}>
      <GlobalStyles>
        <Suspense fallback={<Loader />}>
          <Router>{renderRoutes(rootRoutes)}</Router>
        </Suspense>
      </GlobalStyles>
    </ThemeProvider>
  );
};

export default App;
